import { render, staticRenderFns } from "./appointSuccess.vue?vue&type=template&id=5af4dc94&scoped=true"
import script from "./appointSuccess.vue?vue&type=script&lang=js"
export * from "./appointSuccess.vue?vue&type=script&lang=js"
import style0 from "./appointSuccess.vue?vue&type=style&index=0&id=5af4dc94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af4dc94",
  null
  
)

export default component.exports